import {
  Directive,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  HostListener,
  OnChanges,
  SimpleChanges
} from '@angular/core';


export class ContentModelDirective implements OnChanges {

   contentModel: string;

   contentModelChange = new EventEmitter<string>();

  constructor(private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['contentModel']) {
      this.refresh();
    }
  }

  
  onBlur() {
    this.emitContentModelChange();
  }

  
  onKeypress(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.emitContentModelChange();
    }
  }

  private emitContentModelChange() {
    const value = this.elementRef.nativeElement.innerText;
    this.contentModelChange.emit(value);
  }

  private refresh() {
    this.elementRef.nativeElement.innerText = this.contentModel;
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[contentModel]'
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'contentModel': [{ type: Input },],
'contentModelChange': [{ type: Output },],
'onBlur': [{ type: HostListener, args: ['blur', ] },],
'onKeypress': [{ type: HostListener, args: ['keypress', ['$event'], ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
